import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import { useAuth } from "../../../contexts/AuthContext";
import { getDashboardData } from "../../../services/dashboard.service";

const staticItemsData = [
  {
    key: "totalContracts",
    title: "Nombre d'élèves",
    icon: "profile-circle",
    background: "#edf8f2",
  },
  {
    key: "totalSignedContracts",
    title: "Nombre de contrats",
    icon: "shopping-bag",
    background: "#ecf9fe",
  },
  {
    key: "totalBrokenContracts",
    title: "Nombre d'entreprises",
    icon: "store",
    background: "#e8f1fd",
  },
];

const Dashboard = ({ className }) => {
  const { currentUser } = useAuth();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getDashboardData();
        setDashboardData(data);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch dashboard data:", err);
        setError("Impossible de charger les données du tableau de bord.");
        setDashboardData({
          totalContracts: 0,
          totalSignedContracts: 0,
          totalBrokenContracts: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const itemsToDisplay = staticItemsData.map(item => ({
    ...item,
    counter: dashboardData ? dashboardData[item.key] : (loading ? "Chargement..." : "N/A"),
  }));

  return (
    <>
      <Card
        className={cn(styles.card, className)}
        title={`Votre tableau de bord, ${currentUser?.first_name || 'Utilisateur'}`}
        classTitle="title-blue"
      >
        <div className={styles.overview}>
          {loading && <p>Chargement des données...</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {!loading && !error && dashboardData && (
            <div className={styles.list}>
              {itemsToDisplay.map((x, index) => (
                <div
                  className={styles.item}
                  key={index}
                  style={{ backgroundColor: x.background }}
                >
                  <div className={styles.icon}>
                    <Icon name={x.icon} size="24" />{" "}
                  </div>
                  <div className={styles.line}>
                    <div className={styles.details}>
                      <div className={styles.category}>{x.title}</div>
                      <div className={styles.counter}>{x.counter}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Card>
    </>
  );
};

export default Dashboard;
